<div class="row">
    <ng-container *ngIf="data.flightData == null">
        <p>No aircraft data available for the selected FBO</p>
    </ng-container>
    <ng-container *ngIf="data.flightData != null">
        <app-aircraft-popup-container
            [flightData]="data.flightData"
            [fboId]="data.fboId"
            [groupId]="data.groupId"
            [isLoading]="false"
            [showFavoriteButton]="true"
            (clickEventListener)="onNoClick()"
        ></app-aircraft-popup-container>
    </ng-container>
</div>
